module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      W. David O. Taylor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("W. David O. Taylor")]), _vm._v(" is assistant professor of theology and culture at Fuller Theological Seminary and the director of Brehm Texas, an initiative in worship, theology, and the arts.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vCl9EB/tc-custom/9781467447911.jpg?1730409274835",
      "alt": "This image is the cover for the book The Theater of God's Glory, The Calvin Institute of Christian Worship Liturgical Studies (CICW)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Theater of God's Glory, The Calvin Institute of Christian Worship Liturgical Studies (CICW)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("A theological framework for the liturgical arts rooted in John Calvin")]), _c('br'), _c('br'), _vm._v(" Both detractors and supporters of John Calvin have deemed him an enemy of the physical body, a pessimist toward creation, and a negative influence on the liturgical arts. But, says W. David O. Taylor, that only tells half of the story."), _c('br'), _c('br'), _vm._v(" Taylor examines Calvin's trinitarian theology as it intersects his doctrine of the physical creation in order to argue for a positive theological account of the liturgical arts. He does so believing that Calvin's theology can serve, perhaps surprisingly, as a rich resource for understanding the theological purposes of the arts in corporate worship."), _c('br'), _c('br'), _vm._v(" Drawing on Calvin's "), _c('i', [_vm._v("Institutes")]), _vm._v(", biblical commentaries, sermons, catechisms, treatises, and worship orders, this book represents one of the most thorough investigations available of John Calvin's theology of the physical creation—and the promising possibilities it opens up for the formative role of the arts in worship.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0